export default __webpack_public_path__ + "static/4_9-fc23c352180c26040b55a968d9eafbcc.png";